<template>
  <div class="bxKb" v-if='kbxmlc'>
    <div class="box noBtn">
      <div class="clear">
        <p class="cont-title lf">开标</p>
        <div class="rt">
          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getData"
            ></el-button>
          </el-input>
        </div>
        <table-tem
          :config="tableConfig"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
        </table-tem>
        <span class="lf pageNum">此次共有{{zgs}}家投标单位，递交投标报价{{bjgs}}家</span>
      </div>
      <el-button v-if="role == 'Z'" :disabled="isNext" @click="bxNextBtn" type="primary lcNext">下一步</el-button>
    </div>
  </div>
  <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>

<script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  components: {
    tableTem,
  },
  computed:{
    role() {
      return localStorage.getItem('role')?localStorage.getItem('role'):'T'
    },
    isNext() {
      return this.kbxmlc.zt == 2
    }
  },
  data() {
    return {
      tbdwmc: "", //查询条件
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "fcqymc",
            title: "投标单位名称",
            align: "center",
          },
          {
            key: "fcsfbj",
            title: "是否报价",
            align: "center",
            showTool: true,
            codeMateVal: {
              0: "未报价",
              1: "已报价",
            },
          },
          {
            key: "fcbjsj",
            title: "最新报价时间",
            align: "center",
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
      },
      bjgs: 0,
      zgs: 0,
      kbxmlc: {}
    };
  },
  created() {
    this.djlcId=this.$route.query.djlcId;
    this.getData()
  },
  methods: {
    getData() {
      let para={
        djlcId:this.djlcId,
        tbdwmc: this.tbdwmc,
        currentPage: this.tableConfig.currentPage,
        pageSize: this.tableConfig.pageSize,
      }
      this.waitLoading=true
      this.$api.kblbList(para).then(res=>{
          if(res.data.meta.success){
            this.tableConfig.data = res.data.data.tbdwList
            this.tableConfig.total = res.data.data.total
            this.bjgs = res.data.data.bjgs
            this.zgs = res.data.data.zgs
            this.kbxmlc = res.data.data.kbxmlc
          }else{
            this.$message({
              type:'error',
              message:res.data.meta.message
            })
          }
          this.waitLoading=false
      }).catch(()=>{})
    },
    bxNextBtn(){
      let para={
        flag:this.kbxmlc.ycdz
      }
      this.waitLoading=true
      this.$emit('bxNextBtn',para)
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>

<style lang='scss' scoped>
.pageNum{
  position: relative;
  bottom: 20px;
}

</style>
